var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { emitter } from '../../../app';
import { Component } from '../../dom';
// import {emitter, /*playClickSound /*, playSound, SOUNDS*/} from '../../../common'
import { CloseBtn } from './CloseBtn/CloseBtn';
import './Modal.less';
var CLOSE_DELAY = 200;
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props, className) {
        if (className === void 0) { className = ''; }
        var _this = _super.call(this, props) || this;
        _this.name = 'Modal';
        _this.content = null;
        _this._closeBtn = new CloseBtn({ onClick: function () { return _this.onClose(); } });
        // prettier-ignore
        _this.el = _this.DIV("".concat(className, " &"), [
            _this.DIV({ className: '&__mask', onClick: function () { return _this.onClose(); } }),
            (_this.content = _this.DIV('&__content')),
        ]);
        emitter.on('lang', function () { return _this.draw(); });
        // @ts-ignore
        if (_this.onResize) {
            window.addEventListener('resize', function () {
                if (_this.isVisible()) {
                    // @ts-ignore
                    _this.onResize();
                }
            });
        }
        if (DEVELOPMENT) {
            setTimeout(function () {
                var name1 = _this.name;
                var name2 = name1.charAt(0).toLowerCase() + name1.slice(1);
                if (location.search.includes(name1) || location.search.includes(name2))
                    _this.show();
            }, 1);
        }
        return _this;
    }
    Modal.prototype.toggle = function (toggle, data) {
        var _this = this;
        if (toggle)
            this.draw();
        var delay = toggle ? 1 : CLOSE_DELAY;
        setTimeout(function () {
            _this.toggleClassName('Modal_visible', toggle);
            if (!toggle && _this.props.onClose)
                _this.props.onClose(data);
            if (toggle && _this.props.onOpen)
                _this.props.onOpen();
            Modal.opened += toggle ? 1 : -1;
        }, delay);
    };
    Modal.prototype.show = function () {
        this.toggle(true);
    };
    Modal.prototype.close = function (data) {
        this.toggle(false, data);
    };
    Modal.prototype.isVisible = function () {
        return this.hasClassName('Modal_visible');
    };
    Modal.prototype.draw = function () {
        this.el.removeChild(this.content);
        this.content = this.DIV('Modal__content', __spreadArray([this._closeBtn], this.getContent(), true));
        this.el.appendChild(this.content);
    };
    Modal.prototype.onClose = function (data) {
        // playSound(SOUNDS.CLOSE)
        // playClickSound()
        this.close(data);
    };
    Modal.prototype.header = function (title) {
        return this.DIV('Modal__header', [this.DIV('Modal__headerTitle', title)]);
    };
    Modal.opened = 0;
    return Modal;
}(Component));
export { Modal };
